import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import {
  checkedListAtom,
  isCheckAllAtom,
  orderbyAtom,
  paginationConfigAtom,
  searchPhraseFilterAtom,
  selectedWebAppsFilterAtom,
} from './WAList/state';
import { appliedWAIdsAtom } from '../WADashboard/state';

export function useOnCompanyChangeWaResetAtoms() {
  const resetSelectedHostIds = useResetAtom(appliedWAIdsAtom);
  const resetOrderbyAtom = useResetAtom(orderbyAtom);
  const resetCheckedListAtom = useResetAtom(checkedListAtom);
  const resetIsCheckAllAtom = useResetAtom(isCheckAllAtom);
  const resetSearchPhraseAtom = useResetAtom(searchPhraseFilterAtom);
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);
  const resetSelectedWebAppsFilterAtom = useResetAtom(
    selectedWebAppsFilterAtom,
  );

  const resetAtoms = () => {
    resetSelectedHostIds();
    resetOrderbyAtom();
    resetCheckedListAtom();
    resetIsCheckAllAtom();
    resetSearchPhraseAtom();
    // Only reset page number, preserve page size
    setPaginationConfig({
      ...paginationConfig,
      page: 1,
    });
    resetSelectedWebAppsFilterAtom();
  };

  return resetAtoms;
}
